var map = {
	"./axe-common.png": 176,
	"./chestplate-common.png": 177,
	"./dagger-common.png": 178,
	"./dagger-epic.png": 179,
	"./dagger-legendary.png": 180,
	"./dagger-rare.png": 181,
	"./dagger-uncommon.png": 182,
	"./dagger-unique.png": 183,
	"./gauntlet-common.png": 184,
	"./greatsword-common.png": 185,
	"./greeves-common.png": 186,
	"./helmet-common.png": 187,
	"./placeholder.png": 188,
	"./shield-common.png": 189,
	"./sword-common.png": 190,
	"./sword-epic.png": 191,
	"./sword-rare.png": 192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93;